import { render, staticRenderFns } from "./LoanCountStatics.vue?vue&type=template&id=60ed3b2a&scoped=true&"
import script from "./LoanCountStatics.vue?vue&type=script&lang=js&"
export * from "./LoanCountStatics.vue?vue&type=script&lang=js&"
import style0 from "./LoanCountStatics.vue?vue&type=style&index=0&id=60ed3b2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed3b2a",
  null
  
)

export default component.exports